import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/input'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const PresenceInDays = () => {
  const { t, residenceType, energyLandscape, updateAddressEnergyLandscape, errors } = useAddress()
  if (residenceType !== 'secondary') return null
  return (
    <FormControl error={getError('numberDays', errors)}>
      <SDInput
        label={t('subscriptionTools:estimator.presence_in_days.label')}
        size={SIZE.compact}
        currentValue={energyLandscape?.numberDays}
        pattern={'[0-9]+'}
        min={'1'}
        max={'7'}
        onBlur={numberDays => updateAddressEnergyLandscape({ numberDays })}
      />
    </FormControl>
  )
}

export default PresenceInDays
